export const SCHEDULE_DATA = [
  {
    section: "MERCHANT MEETINGS",
    color: "primary",
    rows: [
      {
        date: "Starting Wednesday, 04/15/2026",
        desc: "Arett Merchant Meetings with Vendors to Discuss Programs for 2026. Item Setup Spreadsheet needs to be submitted within two weeks of your Arett Merchant meeting.",
      },
    ],
  },
  {
    section: "SALES MEETINGS",
    color: "primary",
    rows: [
      {
        date: "Tuesday, 07/21/2026 – Thursday, 07/23/2026",
        desc: "Virtual Sales Meeting Open House",
      },
      {
        date: "Tuesday, 08/18/2026 – Wednesday, 08/19/2026",
        desc: "Virtual Sales Meeting Open House",
      },
    ],
  },
  {
    section: "HOTEL DISCOUNT BOOKING DEADLINE",
    color: "primary",
    rows: [{ date: "", desc: "See Hotel Reservation Page. (Go to Tab 4)" }],
  },
  {
    section: "EXHIBITOR TRAINING MEETINGS",
    color: "primary",
    rows: [
      {
        date: "Mid-August\nCheck Vendor Portal for date/time",
        desc: "ALL EXHIBITORS TRAINING MEETINGS Mandatory to Attend. Register in your vendor portal. General Show Information, How to Place Orders at the Show & Q&A",
      },
      {
        date: "Tuesday, 09/15/2026 \n3:00 PM – 4:00 PM",
        desc: "On-site Exhibitor Training & Q&A Located near the internet cafe. Please review training material located within your vendor portal prior to attending.",
      },
    ],
  },
  {
    section: "ADVANCED FREIGHT",
    color: "primary",
    rows: [
      {
        date: "Saturday, 08/29/2026",
        desc: "Advanced Freight Deadline to General Exposition Services Advance Warehouse",
      },
    ],
  },
  {
    section: "SHOW SCHEDULE MOVE-IN AND SETUP",
    color: "primary",
    rows: [
      {
        date: "Monday, 09/14/2026 \n7:00 AM – 6:00 PM",
        desc: "\nExhibitor Move-In/Set-up",
      },
      {
        date: "Tuesday, 09/15/2026\n7:00 AM – 5:30 PM\n2:00 PM\n3:00 PM – 6:00 PM",
        desc: "\nExhibitor Move-In/Setup\nAll freight load-in and carry-in deadline. Freight doors close at 2:00 PM.\nExhibitor Training Meetings and New Vendor Training Meetings",
      },
      {
        date: "Wednesday, 09/16/2026\n8:00 AM – 10:30 AM\n8:00 AM\n12:00 PM – 2:00 PM\n3:00 PM – 5:00 PM\n6:00 PM\n6:30 PM - 9:30 PM",
        desc: "\nContinental breakfast on Show floor\nShow Day 1 Opens\nLunch on Show Floor\nSnack Break 3:00 pm – 5:00 pm\nShow Day 1 Closes\nMain Event at Bally's Atlantic City Hotel & Casino; 6th Floor",
      },
      {
        date: "Thursday, 09/17/2026\n8:00 AM – 10:30 AM\n8:00 AM\n8:00 AM to 10:30 AM\n12:00 PM to 2:00 PM\n4:00 PM",
        desc: "\nContinental breakfast on Show floor\nShow Day 2 Opens\nContinental breakfast on Show floor\nLunch on Show Floor\nShow Day 2 Closes",
      },
    ],
  },
];

export const HOTEL_DATA = [
  {
    name: "Bally's Atlantic City Hotel and Casino",
    address: "1900 Pacific Ave | Atlantic City, NJ 08401",
    color: "#0A7C59",
    rates: [
      { night: "Monday, September 14th", rate: "$106.08*" },
      { night: "Tuesday, September 15th", rate: "$106.08*" },
      { night: "Wednesday, September 16th", rate: "$106.08*" },
      { night: "Thursday, September 17th", rate: "$106.08*" },
      { night: "Basic Internet", rate: "Included" },
      { night: "Room Deadline", rate: "September 1st" },
      {
        night: "Cancellation with no penalty",
        rate: "48 hours prior to check-in",
      },
      { night: "Self-Parking", rate: "$10/stay" },
      { night: "Group Name", rate: "Arett Sales Open House" },
      { night: "Group Code", rate: "SAR914" },
      { night: "Phone Reservations", rate: "609-340-2000" },
    ],
    bookingLink: "Click here to book at Bally's",
    bookingUrl: "https://ballysac.book.pegsbe.com/promo?offerCode=SAR914&hotel=BAC",
    note: "*Price includes room rate, resort fee, and occupancy fee. State, local and resort room taxes are additional.",
  },
  {
    name: "Sheraton AC",
    address: "2 Convention Blvd | Atlantic City, NJ 08401",
    color: "#1A56A0",
    rates: [
      { night: "Monday, September 14th", rate: "$131.66*" },
      { night: "Tuesday, September 15th", rate: "$131.66*" },
      { night: "Wednesday, September 16th", rate: "$131.66*" },
      { night: "Thursday, September 17th", rate: "$131.66*" },
      { night: "Basic Internet", rate: "Included" },
      { night: "Room Deadline", rate: "August 26th" },
      {
        night: "Cancellation with no penalty",
        rate: "48 hours prior to check-in",
      },
      { night: "Self-Parking", rate: "$15/day" },
      { night: "Group Name", rate: "Arett Sales Open House 2026" },
      { night: "Group Code", rate: "M-VQ0G743" },
      { night: "Phone Reservations", rate: "609-344-3535" },
    ],
    bookingLink: "Click to Book Sheraton Atlantic City",
    bookingUrl: "https://book.passkey.com/event/51209178/owner/2839/home",
    note: "*Price includes room rate. State and local taxes and tourism fee are additional.",
  },
];
